import React, { Component } from 'react';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import AddForm from './components/AddForm';
import Table from './components/Table';
import API from '../../services/API';
import Icon from "../../components/Icon";
import {Alert, Button, ButtonGroup, Col, Row} from "react-bootstrap";

class PushapiBlock extends Component {
    constructor() {
        super();

        this.state = {
            affidValues: [],
            report: [],
            sortParam: null,
            sortOrder: 1,
            isLoading: false,
            alert: null
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleAddFormSubmit = this.handleAddFormSubmit.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleSync = this.handleSync.bind(this);
    }

    componentDidMount() {
        API.PushapiConfig.getAffid()
            .then(affids => this.setState({ affidValues: affids }));
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        report.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    handleSubmit(filters) {
        this.setState({ isLoading: true });

        API.PushapiBlock.get(filters).then(({ report }) => {
            this.setState({ report, isLoading: false })
        });
    }

    handleAddFormSubmit({ affid, subid }) {
        this.setState({ isLoading: true });

        API.PushapiBlock.save(affid, subid)
            .then(() => {
                this.setState({ isLoading: false, alert: 'success' })
            })
            .catch(() => this.setState({ isLoading: false, alert: 'danger' }))
            .then(() => {
                setTimeout(() => this.setState({ alert: null }), 5000);
            });
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, configToUpdate: null });
    }

    getForm() {
        if(this.state.isShowForm) {
            return <AddForm
                onSubmit={this.handleAddFormSubmit}
                onFormHide={this.handleFormHide}/>;
        }
    }

    handleRemoveBtnClick(id) {
        this.setState({ isLoading: true });

        API.PushapiBlock.remove(id)
            .then(() => {
                const report = this.state.report.reduce((arr, row) => {
                    if(row.id != id) arr.push(row);

                    return arr;
                }, []);

                this.setState({ isLoading: false, report });
            });
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync([ 'pushapi-eu-clk', 'pushapi-eu', 'pushapi-us', 'pushapi-us-clk', ], 'block')
            .then(() => {
                this.setState({ isLoading: false });
            })
    }

    getAlert() {
        const { alert } = this.state;

        if(alert) {
            const message = alert === 'success' ? 'Success!' : 'Error!';

            return (
                <div style={{ position: 'absolute', top: '20px', left: '50%', transform: 'translateX(-50%)', zIndex: '99999', width: '150px', textAlign: 'center' }}>
                    <Alert bsStyle={alert}>
                        {message}
                    </Alert>
                </div>
            );
        }
    }

    getTable() {
        const { report, reportTotal } = this.state;

        return report.length ?
            <Table report={report} total={reportTotal} onSortChange={this.handleSort} onRemove={this.handleRemoveBtnClick}/> :
            <p>No Data</p>
    }

    render() {
        const { isLoading, affidValues } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Pushapi Block"/>
                <Row>
                    <Col lg={12}>
                        <ButtonGroup className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                            <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
                <Form onSubmit={this.handleSubmit} affidValues={affidValues}/>
                {this.getForm()}
                {this.getAlert()}
                {this.getTable()}

            </Container>
        );
    }
}

export default PushapiBlock;


// WEBPACK FOOTER //
// ./src/scenes/PushapiBlock/index.js